import * as React from 'react';
import {
    List,
    TextField,
    EditButton,
    Create,
    SimpleForm,
    TextInput,
    Edit,
    required,
    TopToolbar
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

import { ImportButton } from 'react-admin-import-csv';
import { CreateButton, ExportButton } from 'ra-ui-materialui';

function transformRows(csvRows: any[]) {
    for (const row of csvRows) {
        delete row.id;
        delete row._id;
        delete row.password;
        delete row.q;
    }

    return csvRows;
}

const ListActions = (props) => {
    const { className, basePath } = props;
    return (
        <TopToolbar className={className}>
            <CreateButton basePath={basePath} />
            <ExportButton />
            <ImportButton {...props} transformRows={transformRows} />
        </TopToolbar>
    );
};

const userFilters = [<TextInput source="all" label="Rechercher" alwaysOn />];

export const TranslationList = (props) => (
    <List {...props} filters={userFilters} actions={<ListActions />} bulkActionButtons={false} sort={{ field: 'name', order: 'ASC' }} perPage={50} pagination={<AdminPagination />} exporter={false}>
        <AdminSelectableDatagrid>
            <TextField source="name" label="Clé" />
            <TextField source="lang_en" label="Anglais" />
            <TextField source="lang_fr" label="Français" />
            <EditButton />
            <HumanDeleteButton fields={["name"]} fallback="cette traduction" />
        </AdminSelectableDatagrid>
    </List>
);

export const TranslationEdit = (props) => (
    <div>
        <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["name"]} fallback="Fiche" />}>
            <SimpleForm redirect="list">
                <TextInput source="name" label="Clé" validate={required()} />
                <TextInput source="lang_en" label="Anglais" validate={required()} options={{ multiline: true, rows:5 }} />
                <TextInput source="lang_fr" label="Français" validate={required()} options={{ multiline: true, rows:5 }} />
            </SimpleForm>
        </Edit>
        <b>&lt;b&gt;Gras&lt;/b&gt;</b>
        <br/>
        &lt;br/&gt; Saut à la ligne
    </div>

);

export const TranslationCreate = (props) => (
    <div>
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput source="name" label="Clé" validate={required()} />
                <TextInput source="lang_en" label="Anglais" validate={required()} options={{ multiline: true, rows:5 }} />
                <TextInput source="lang_fr" label="Français" validate={required()} options={{ multiline: true, rows:5 }} />
            </SimpleForm>
        </Create>
        <b>&lt;b&gt;Gras&lt;/b&gt;</b>
        <br/>
        &lt;br/&gt; Saut à la ligne
    </div>

);
